<template>
  <div
    :class="['nd-drag-coupon']"
    v-if="showDom && visible"
    ref="dragDom"
    data-sensors-exposure-event-name="Element_Exposure"
    data-sensors-exposure-property-element_positon="float"
    :data-sensors-exposure-property-element_type="flow.textKey"
    @click="goWithdraw"
  >
    <div class="coupon-container"></div>
    <p> {{ flow.text }} </p>
    <i class="close" @click="handleClose"></i>
  </div>
</template>

<script>

export default {
  props: {
    flow: {
      type: Object,
      default: () => ({})
    },
    ftype: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isDragged: false,
      domLeft: 0,
      domTop: 0,
      initX: 0,
      initY: 0,
      open: true,
      visible: true,
      topPosition: 0 // 页面顶部的限制距离
    }
  },
  mounted () {
    const dragDom = this.$refs.dragDom
    if (!dragDom) return
    // 页面宽度和高度
    const pageWidth = document.documentElement.clientWidth
    let pageHeight = document.documentElement.clientHeight
    // 拖拽元素宽度和高度
    const dragWidth = dragDom.offsetWidth
    const dragHeight = dragDom.offsetHeight

    // 初始化位置信息
    const dragPosition = JSON.parse(
      sessionStorage.getItem('dragPosition') || 'null'
    )
    if (dragPosition) {
      dragDom.style.top = dragPosition.top
      if (dragPosition.left) {
        dragDom.style.left = dragPosition.left
      } else {
        // 默认靠右显示
        dragDom.style.left = `${pageWidth - dragWidth - 10}px`
      }
    } else {
      dragDom.style.top = pageHeight - dragHeight - 100 + 'px'
      // 默认靠右显示
      dragDom.style.left = `${pageWidth - dragWidth - 10}px`
    }
    dragDom.addEventListener('touchstart', (e) => {
      e.stopPropagation()
      this.isDragged = true
      this.initX = e.touches[0].clientX
      this.initY = e.touches[0].clientY
      this.domLeft = dragDom.offsetLeft
      this.domTop = dragDom.offsetTop
    })
    dragDom.addEventListener('touchmove', (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (this.isDragged) {
        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        // 鼠标移动的距离
        const offsetX = x - this.initX
        const offsetY = y - this.initY
        // 鼠标移动后元素的新位置
        const newLeft = this.domLeft + offsetX
        const newTop = this.domTop + offsetY

        if (newLeft < 0) {
          dragDom.style.left = 10 + 'px'
        } else if (newLeft > pageWidth - dragWidth) {
          dragDom.style.left = pageWidth - dragWidth + 'px'
        } else {
          dragDom.style.left = newLeft + 'px'
        }
        if (newTop < this.topPosition) {
          dragDom.style.top = this.topPosition + 'px'
        } else if (newTop > pageHeight - dragHeight) {
          dragDom.style.top = pageHeight - dragHeight + 'px'
        } else {
          dragDom.style.top = newTop + 'px'
        }
      }
    })
    dragDom.addEventListener('touchend', () => {
      this.isDragged = false
  
      // 获取页面宽度和元素当前位置
      const pageWidth = document.documentElement.clientWidth
      const elementCenter = dragDom.offsetLeft + (dragDom.clientWidth / 2)
  
      // 判断元素中心点是在屏幕左半边还是右半边
      if (elementCenter < pageWidth / 2) {
        // 如果在左半边，则靠左吸附
        dragDom.style.left = '10px'
      } else {
        // 如果在右半边，则靠右吸附
        dragDom.style.left = `${pageWidth - dragDom.clientWidth - 10}px`
      }
  
      // 保存位置到 sessionStorage
      sessionStorage.setItem(
        'dragPosition',
        JSON.stringify({
          top: dragDom.style.top,
          left: dragDom.style.left
        })
      )
    })
  },
  computed: {
    showDom () {
      return this.isIntervalDayBySession(`repayDrag-${this.ftype}`, 1)
    }
  },
  methods: {
    goWithdraw () {
      this.$sensors.track('$WebClick', { element_type: this.flow.textKey })
      this.$router.push('/middle/limit')
    },
    handleClose () {
      this.visible = false
      sessionStorage.setItem(`repayDrag-${this.ftype}`, new Date().getTime())
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.nd-drag-coupon {
  width:140px;
  height: 100px;
  position: fixed;
  top: 0;
  right: 20px;
  z-index: 99999;
  display: flex;
  box-sizing: content-box;
  flex-direction: column;
  align-items: center;
  .coupon-container {
    width:120px;
    height:80px;
    background:url('./images/img_hongbao.png') no-repeat;
    background-size: 3000px 80px;
    animation: cat steps(25) infinite 1s;
  }
  .close {
    width:24px;
    height:24px;
    position: absolute;
    top: -25px;
    right: 15px;
    background:url('./images/btn_close@2x.png') no-repeat;
    background-size: 24px 24px;
  }
  @keyframes cat {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: -3000px 0;
    }
    
  }
  p {
    height: 32px;
    line-height: 32px;
    background: #FFEA64;
    border-radius: 16px;
    padding: 0px 10px;
    border-radius: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #B13314;
    text-align: center;
    margin-top: -20px;
  }


}
</style>